import registerServiceWorker from './registerServiceWorker'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'


import enhanceStore from './Store'
import reduce from './reduce'
import Routes from './routes'

const store = enhanceStore(reduce)

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Routes />
    </Router>
  </Provider>,
  document.querySelector('#root')
)
registerServiceWorker()




// WEBPACK FOOTER //
// ./src/index.js